webpackJsonp([0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var platform_browser_dynamic_1 = __webpack_require__(1);
	var core_1 = __webpack_require__(7);
	var app_component_1 = __webpack_require__(280);
	if (true) {
	    core_1.enableProdMode();
	}
	platform_browser_dynamic_1.bootstrap(app_component_1.AppComponent, []);


/***/ },

/***/ 280:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(7);
	__webpack_require__(281);
	var AppComponent = (function () {
	    function AppComponent() {
	    }
	    AppComponent = __decorate([
	        core_1.Component({
	            selector: 'my-app',
	            template: __webpack_require__(285),
	            styles: [__webpack_require__(287)]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AppComponent);
	    return AppComponent;
	}());
	exports.AppComponent = AppComponent;


/***/ },

/***/ 281:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 285:
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<main>\n  <h1>Hello from Angular 2 App with Webpack</h1>\n  <img src=\"" + __webpack_require__(286) + "\">\n</main>";

/***/ },

/***/ 286:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/angular.41eaea26322786b81b064790d8b49fbd.png";

/***/ },

/***/ 287:
/***/ function(module, exports) {

	module.exports = "main {\n  padding: 1em;\n  font-family: Arial, Helvetica, sans-serif;\n  text-align: center;\n  margin-top: 50px;\n  display: block;\n}"

/***/ }

});


/** WEBPACK FOOTER **
 ** app.023d5b70796b5b85ef3e.js
 **/